import type { User } from '@auth0/auth0-react';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type AuthStatus =
  | 'not-checked'
  | 'pending'
  | 'authorized'
  | 'unauthorized';

export interface AuthState {
  isFirstLogin: boolean;
  user?: User;
  authStatus: AuthStatus;
  showUnauthorised: boolean;
  login: Function;
  logout: Function;
  getAuthToken: Function;
}

const initialState: AuthState = {
  isFirstLogin: false,
  authStatus: 'not-checked',
  showUnauthorised: false,
  login: () => {},
  logout: () => {},
  getAuthToken: () => {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsFirstLogin: (state, isFirstLogin: PayloadAction<boolean>) => {
      state.isFirstLogin = isFirstLogin.payload;
    },
    setUser: (state, user: PayloadAction<User>) => {
      state.user = user.payload;
    },
    setAuthStatus: (state, authStatus: PayloadAction<AuthStatus>) => {
      state.authStatus = authStatus.payload;
    },
    setLogin: (state, login: PayloadAction<Function>) => {
      state.login = login.payload;
    },
    setLogout: (state, logout: PayloadAction<Function>) => {
      state.logout = logout.payload;
    },
    setGetAuthToken: (state, getAuthToken: PayloadAction<Function>) => {
      state.getAuthToken = getAuthToken.payload;
    },
    setShowUnauthorised: (state, showUnauthorised: PayloadAction<boolean>) => {
      state.showUnauthorised = showUnauthorised.payload;
    },
  },
});

export const {
  setGetAuthToken,
  setLogin,
  setUser,
  setLogout,
  setAuthStatus,
  setIsFirstLogin,
  setShowUnauthorised,
} = authSlice.actions;

export default authSlice.reducer;
